import React, { useState, useEffect } from 'react';
import './CollapsibleSection.css';

// Chevron down icon
const ChevronIcon = ({ isExpanded }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`collapsible-icon ${isExpanded ? 'expanded' : ''}`}
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

function CollapsibleSection({ title, name, defaultExpanded = false, children }) {
  const storageKey = `memberForm.sections.${name}`;

  // Initialize state from localStorage or use default
  const [isExpanded, setIsExpanded] = useState(() => {
    const stored = localStorage.getItem(storageKey);
    return stored !== null ? stored === 'true' : defaultExpanded;
  });

  // Persist to localStorage whenever state changes
  useEffect(() => {
    localStorage.setItem(storageKey, isExpanded.toString());
  }, [isExpanded, storageKey]);

  const toggleExpanded = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <div className="collapsible-section">
      <button
        type="button"
        className="collapsible-header"
        onClick={toggleExpanded}
        aria-expanded={isExpanded}
        aria-controls={`section-${name}`}
      >
        <ChevronIcon isExpanded={isExpanded} />
        <span className="collapsible-title">{title}</span>
      </button>

      {isExpanded && (
        <div
          id={`section-${name}`}
          className="collapsible-content"
        >
          {children}
        </div>
      )}
    </div>
  );
}

export default CollapsibleSection;
